exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc[data-v-7b330ea1] {\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.25rem;\n  margin-bottom: 1.875rem;\n}\n.desc .num[data-v-7b330ea1] {\n  font-size: 1.5625rem;\n  color: red;\n}\n.hidden-text[data-v-7b330ea1] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}", ""]);

// exports
